import React from "react";
import AdfoxAdaptive from "./AdFoxAdaptive";
import { selectVariant } from "../../utils/adVariant";

export function AdfoxSticky({ isFull, isDesktop, options, className = "adfox" }) {
    const option = selectVariant(options, isFull, isDesktop);

    if (!option) {
        return null;
    }

    return isDesktop ? (
        <AdfoxAdaptive options={option} className={className} />
    ) : (
        <div style={{ height: "600px" }}>
            <div className="sticky-block">
                <div className="sticky-block-content">
                    <AdfoxAdaptive options={option} className={className} />
                </div>
            </div>
        </div>
    );
}
